// @mui material components
import { GetApp, Visibility } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function TableActionCell({ invoice }) {
  const handleView = () => {
    console.log(`Here..`);
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography
        variant="body1"
        color="secondary"
        sx={{ cursor: "pointer", lineHeight: 0 }}
        onClick={handleView}
      >
        <Tooltip title="Προβολή" placement="top">
          <Visibility />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );
}

export default TableActionCell;
